import api from './api';

// Specialty tipləri
export interface SpecialtyTree {
  id: number;
  name: string;
  parent: number | null;
  company: number;
  description: string;
  is_active: boolean;
  full_path: string;
  level: number;
  is_leaf: boolean;
  teacher_count: number;
  children?: SpecialtyTree[];
  created_at: string;
  updated_at: string;
}

export interface SpecialtySelect {
  value: number;
  label: string;
  full_path: string;
  level: number;
  parent: number | null;
}

export interface SpecialtyCreate {
  name: string;
  parent?: number | null;
  company: number;
  description?: string;
  is_active: boolean;
}

export interface SpecialtyFilters {
  search?: string;
  parent?: number | null;
  is_active?: boolean;
  level?: number;
}

export interface APIResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
  errors?: any;
}

class SpecialtyAPI {
  // İxtisas ağacını əldə et
  async getSpecialtyTree(companyId: number): Promise<APIResponse<SpecialtyTree[]>> {
    try {
      const response = await api.get(`/specialties/tree/?company=${companyId}`);
      
      return {
        success: true,
        data: response.data
      };
    } catch (error: any) {
      console.error('İxtisas ağacı yüklənmədi:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'İxtisaslar yüklənmədi'
      };
    }
  }

  // Select üçün ixtisas seçimləri
  async getSpecialtySelectOptions(companyId: number): Promise<APIResponse<SpecialtySelect[]>> {
    try {
      const response = await api.get(`/specialties/select_options/?company=${companyId}`);
      
      return {
        success: true,
        data: response.data
      };
    } catch (error: any) {
      console.error('İxtisas seçimləri yüklənmədi:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'İxtisas seçimləri yüklənmədi'
      };
    }
  }

  // Yeni ixtisas yarat
  async createSpecialty(specialtyData: SpecialtyCreate): Promise<APIResponse<SpecialtyTree>> {
    try {
      const response = await api.post('/specialties/', specialtyData);
      
      return {
        success: response.data.success,
        message: response.data.message,
        data: response.data.data
      };
    } catch (error: any) {
      console.error('İxtisas yaradılmadı:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'İxtisas yaradılmadı',
        errors: error.response?.data?.errors
      };
    }
  }

  // İxtisası yenilə
  async updateSpecialty(id: number, specialtyData: Partial<SpecialtyCreate>): Promise<APIResponse<SpecialtyTree>> {
    try {
      const response = await api.put(`/specialties/${id}/`, specialtyData);
      
      return {
        success: response.data.success,
        message: response.data.message,
        data: response.data.data
      };
    } catch (error: any) {
      console.error('İxtisas yenilənmədi:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'İxtisas yenilənmədi',
        errors: error.response?.data?.errors
      };
    }
  }

  // İxtisası sil
  async deleteSpecialty(id: number): Promise<APIResponse<null>> {
    try {
      const response = await api.delete(`/specialties/${id}/`);
      
      return {
        success: response.data.success,
        message: response.data.message
      };
    } catch (error: any) {
      console.error('İxtisas silinmədi:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'İxtisas silinmədi'
      };
    }
  }

  // İxtisası köçür (drag & drop)
  async moveSpecialty(specialtyId: number, newParentId?: number): Promise<APIResponse<SpecialtyTree>> {
    try {
      const response = await api.post(`/specialties/${specialtyId}/move/`, {
        new_parent_id: newParentId || null
      });
      
      return {
        success: response.data.success,
        message: response.data.message,
        data: response.data.data
      };
    } catch (error: any) {
      console.error('İxtisas köçürülmədi:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'İxtisas köçürülmədi'
      };
    }
  }

  // İxtisas statistikaları
  async getSpecialtyStatistics(companyId?: number): Promise<APIResponse<any>> {
    try {
      const url = companyId 
        ? `/specialties/statistics/?company=${companyId}`
        : '/specialties/statistics/';
        
      const response = await api.get(url);
      
      return {
        success: true,
        data: response.data
      };
    } catch (error: any) {
      console.error('Statistikalar yüklənmədi:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Statistikalar yüklənmədi'
      };
    }
  }
}

export const specialtyAPI = new SpecialtyAPI();